<form
  [formGroup]="addBehaviorForm"
  (ngSubmit)="onSubmit()"
  [class.disabled]="isLoading()"
  id="addBehaviorForm"
>
  <h2 class="form-title">{{ titleName }}</h2>

  <div class="control-row" *ngIf="!hideSessionSelector && !creatingSession()">
    <div class="control no-margin">
      <label for="target">Session:</label>
      <p-dropdown
        id="sessionDropdown"
        filter="true"
        autoWidth="false"
        [style]="{ width: '100%' }"
        appendTo="body"
        [options]="sessions()"
        [(ngModel)]="selectedSession"
        [ngModelOptions]="{standalone: true}"
        optionLabel="label"
        optionValue="value"
        [loading]="isLoading()"
        (onChange)="changedSession($event)"
      >
      <ng-template pTemplate="selectedSession" let-selectedOption>
        <div class="flex align-items-center gap-2">
          <div>
            <small> {{ selectedSessionLabel(selectedOption.value) }}</small><br>
            {{ this.formattedDates(selectedOption.value.StartedDate, selectedOption.value.FinishedDate) }}
           
          </div>
        </div>
      </ng-template>
      </p-dropdown>
      <small>If the session was still not created, you can create it by clicking <a href="javascript:void(0)" (click)="showCreateSession()">here</a>.</small>
    </div>
  </div>

  <div class="control-row" *ngIf="creatingSession()">
    <div class="control no-margin">
      <label for="target">Create New Session:</label>
      <div>
        <div >
          <label for="startDate">New Session Start Date</label>
          <input 
            id="startDate"
            type="datetime-local" 
            pInputText 
            [(ngModel)]="newSessionStartDate" 
            [ngModelOptions]="{standalone: true}"
          />
        </div>
        <div >
          <label for="endDate">New Session End Date</label>
          <input 
            id="endDate"
            type="datetime-local" 
            pInputText 
            [(ngModel)]="newSessionEndDate" 
            [ngModelOptions]="{standalone: true}"
          />
        </div>
      </div>
      <small><a href="javascript:void(0)" (click)="hideCreateSession()">Back to select session</a></small>
    </div>
  </div>

  @if (!hideBehaviorSelector) { 
    <div class="control-row">
      <div class="control no-margin">
        <label for="behavior">Behavior:</label>
        <p-dropdown
          id="behaviorDropdown"
          filter="true"
          autoWidth="false"
          [style]="{ width: '100%' }"
          appendTo="body"
          [options]="behaviors()"
          formControlName="behavior"
          optionLabel="label"
          [loading]="isLoading()"
          (onChange)="changedBehavior($event)"
        >
        </p-dropdown>
        @if(addBehaviorForm.controls.behavior.invalid &&
        addBehaviorForm.controls.behavior.touched) {
        <span class="control-error">Behavior is required.</span>
        }
      </div>
    </div>
    }
  <div class="control-row" *ngIf="shouldShowStaffSelector()">
    <div class="control no-margin">
      <label for="selectedStaff">Staff:</label>
      <p-dropdown
        id="selectedStaffDropdown"
        filter="true"
        autoWidth="false"
        [style]="{ width: '100%' }"
        appendTo="body"
        [options]="staffOptions()"
        formControlName="selectedStaff"
        optionLabel="label"
        [loading]="isLoading()"
        [disabled]="!selectedSession"
      >
      </p-dropdown>
    </div>
  </div>

  <div class="control-row">
    <div class="control no-margin">
      <label for="recordedDate">{{ behaviorIsFrequency() ? 'Start Date/Time' : 'Recorded Date' }}</label>
      <input
        type="datetime-local"
        [style]="{ width: '100%' }"
        appendTo="body"
        class="form-control"
        name="recordedDate"
        formControlName="recordedDate"
        autocomplete="off"
      />
    </div>
  </div>

  @if (behaviorIsFrequency()) {
    <div class="control-row">
      <div class="control no-margin">
        <label for="frequencyOccurrences">Occurrences:</label>
        <p-inputNumber
          inputId="frequencyOccurrences"
          formControlName="frequencyOccurrences"
          [style]="{ width: '100%' }"
          [showButtons]="true"
          [min]="1"
          [max]="maxBulkFrequencyOccurrences"
          [step]="1"
          [maxFractionDigits]="0"
        />
        @if (addBehaviorForm.controls.frequencyOccurrences.invalid &&
          addBehaviorForm.controls.frequencyOccurrences.touched) {
          <span class="control-error">
            Occurrences must be a whole number from 1 to {{ maxBulkFrequencyOccurrences }}.
          </span>
        }
      </div>
    </div>

    @if (showFrequencyEndDate()) {
      <div class="control-row">
        <div class="control no-margin">
          <label for="frequencyEndDate">End Date/Time</label>
          <input
            id="frequencyEndDate"
            type="datetime-local"
            [style]="{ width: '100%' }"
            class="form-control"
            formControlName="frequencyEndDate"
            autocomplete="off"
          />
          @if (addBehaviorForm.controls.frequencyEndDate.invalid &&
            addBehaviorForm.controls.frequencyEndDate.touched) {
            <span class="control-error">
              End date/time is required when adding more than one occurrence.
            </span>
          }
        </div>
      </div>
    }
  }


  @if(selectedBehavior() && !behaviorIsFrequency()) {
    <div class="control-row">
      <div class="control no-margin">
          @if (behaviorIsDuration()) {
              <label for="duration">Duration (in minutes): </label>
          } @else if (behaviorIsInterval()) {
              <label for="happenedDuringInterval">Happened during interval:</label>
          } @else if (behaviorIsIntensity()) {
              <label for="intensityValue">Intensity:</label>
          } @else {
              <label for="value">Value:</label>
          } 
          @if (behaviorIsDuration()) {
              <p-inputNumber
              autoWidth="false"
              [style]="{ width: '100%' }"
              formControlName="duration"
              [showButtons]="true"
              [minFractionDigits]="1"
              [maxFractionDigits]="2"
              />
          } @else if (behaviorIsInterval()) {
              <p-checkbox
                formControlName="happenedDuringInterval"
                [style]="{ width: '100%' }"
              />
          } @else if (behaviorIsIntensity()) {
              <p-selectButton
                formControlName="intensityValue"
                [options]="intensityOptions()"
                optionLabel="label"
                optionValue="value"
              />
          } @else {
              <input
              pInputText
              type="text"
              formControlName="textValue"
              [style]="{ width: '100%' }"
              placeholder="Enter a value"
              />
          }
      </div>
    </div>
    }

  <!-- Antecedent picker with other option-->
  <div class="control-row">
    <div class="control no-margin">
      <label for="antecedent">Antecedent:</label>
      <p-multiSelect
        id="antecedentDropdown"
        filter="true"
        autoWidth="false"
        [style]="{ width: '100%' }"
        appendTo="body"
        [options]="antecedents()"
        formControlName="selectedAntecedent"
        optionLabel="PatientBehaviorAntecedent"
        [loading]="isLoading()"
        (onChange)="selectedAntecedents.set($event.value)"
      >
      </p-multiSelect>
    </div>
  </div>

  <!-- Consequence picker with other option-->
  <div class="control-row">
    <div class="control no-margin">
        <label for="consequence">Consequence:</label>
        <p-multiSelect
          id="consequenceDropdown"
          filter="true"
          autoWidth="false"
          [style]="{ width: '100%' }"
          appendTo="body"
          [options]="consequences()"
          formControlName="selectedConsequence"
          optionLabel="PatientBehaviorConsequence"
          [loading]="isLoading()"
          (onChange)="selectedConsequences.set($event.value)"
        />
    </div>
  </div>

  <!-- Severity picker-->
  <div class="control-row">
    <div class="control no-margin">
        <label for="severity">Severity:</label>
        <p-dropdown
          id="severityDropdown"
          filter="true"
          autoWidth="false"
          [style]="{ width: '100%' }"
          appendTo="body"
          [options]="severities()"
          formControlName="selectedSeverity"
          optionLabel="PatientBehaviorSeverity"
          [loading]="isLoading()"
          (onChange)="selectedSeverity.set($event.value)"
        />
    </div>
  </div>

  <!-- Response picker-->
  <div class="control-row">
    <div class="control no-margin">
        <label for="response">Response:</label>
        <p-dropdown
          id="responseDropdown"
          filter="true"
          autoWidth="false"
          [style]="{ width: '100%' }"
          appendTo="body"
          [options]="responses()"
          formControlName="selectedResponse"
          optionLabel="PatientBehaviorResponse"
          [loading]="isLoading()"
          (onChange)="selectedResponse.set($event.value)"
        />
    </div>
  </div>

  <!-- Location picker-->
  <div class="control-row">
    <div class="control no-margin">
        <label for="location">Location:</label>
        <p-dropdown
          id="locationDropdown"
          filter="true"
          autoWidth="false"
          [style]="{ width: '100%' }"
          appendTo="body"
          [options]="locations()"
          formControlName="selectedLocation"
          optionLabel="PatientBehaviorLocation"
          [loading]="isLoading()"
          (onChange)="selectedLocation.set($event.value)"
        />
    </div>
  </div>

  @if (isLoading()) {
  <div class="loading">
    <app-loading-indicator />
  </div>
  }

  <p class="actions" style="position: sticky; bottom: 0" id="addTargetButtons">
    <button
      type="button"
      class="switch-mode-button"
      style="margin-right: auto; cursor: pointer;"
      (click)="onCancel()"
      [disabled]="isLoading()"
    >
      Cancel
    </button>
    <button
      type="submit"
      id="saveTargetButton"
      class="side-menu-button2"
      style="cursor: pointer;"
      [disabled]="isLoading()"
    >
      {{ actionName }}
    </button>
  </p>
</form>
